"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var au_1 = __importDefault(require("./au"));
var gb_1 = __importDefault(require("./gb"));
var nanp_1 = __importDefault(require("./nanp"));
var unknown_1 = __importDefault(require("./unknown"));
var decorators = {
    AG: nanp_1.default,
    AI: nanp_1.default,
    AS: nanp_1.default,
    AU: au_1.default,
    BB: nanp_1.default,
    BM: nanp_1.default,
    BS: nanp_1.default,
    CA: nanp_1.default,
    DM: nanp_1.default,
    DO: nanp_1.default,
    GB: gb_1.default,
    GD: nanp_1.default,
    GU: nanp_1.default,
    JM: nanp_1.default,
    KN: nanp_1.default,
    KY: nanp_1.default,
    LC: nanp_1.default,
    MS: nanp_1.default,
    NANP: nanp_1.default,
    PR: nanp_1.default,
    SX: nanp_1.default,
    TC: nanp_1.default,
    TT: nanp_1.default,
    US: nanp_1.default,
    VC: nanp_1.default,
    VG: nanp_1.default,
    VI: nanp_1.default,
    unknown: unknown_1.default,
};
exports.default = decorators;
//# sourceMappingURL=index.js.map